export default function videoWidget() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  const addVideoTag = true;
  const tagText = 'Watch';

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    autoPlayVideo: false,
    loopVideo: true, // autoPlayVideo must be enabled
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1) {
        addVideoTag && $('#videoSection').append(`<div class="video-tag">${tagText}</div`);
      } else {
        $('#videoSection').remove();
        $('.videoWidget-container').addClass('no-video');
      }
    },
  });
}
